import styled from 'styled-components';
import { Tag } from '../../../ReferralInfo/ReferralInfo.styles';

export const DeletedTag = styled(Tag)`
  width: auto;
  height: auto;
  padding: 0.2rem 0.8rem;
  margin-left: 1.2rem;
`;
